<template>
  <footer>
    <p>&copy; 2026 Pam's Bits and Bridles. All rights reserved.</p>
    <p>Contact: (443) 619-3904 | pamsbitsandbridles@gmail.com</p>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

<style scoped>
footer {
  text-align: center;
  padding: 40px 20px;
  background: #1A2B49; /* Logo Navy */
  color: #fff;
  font-family: 'Lato', sans-serif;
}

footer p {
  margin: 5px 0;
}
</style>